/**
 * 健康度バッジコンポーネント
 *
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business プロジェクト健康度をS/A/B/C/Dの色付きバッジで表示
 * @graph-connects none
 */

import { useTranslation } from 'react-i18next';
import type { HealthScore, HealthGrade } from '../../../types/project.js';

/** 健康度バッジの色設定 */
/** @graph-connects none */
export const HEALTH_COLORS: Record<HealthGrade, { bg: string; text: string; labelKey: string }> = {
  S: { bg: '#16a34a', text: '#fff', labelKey: 'projects.health.grades.S' },
  A: { bg: '#eab308', text: '#422006', labelKey: 'projects.health.grades.A' },
  B: { bg: '#f97316', text: '#fff', labelKey: 'projects.health.grades.B' },
  C: { bg: '#ef4444', text: '#fff', labelKey: 'projects.health.grades.C' },
  D: { bg: '#7f1d1d', text: '#fff', labelKey: 'projects.health.grades.D' },
};

/** 健康度バッジ */
/** @graph-connects none */
export function HealthBadge({ health }: { health: HealthScore | null }) {
  const { t } = useTranslation();
  if (!health) return <span className="text-xs text-[var(--color-text-muted)]">-</span>;
  const cfg = HEALTH_COLORS[health.grade];
  return (
    <span
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-bold"
      style={{ backgroundColor: cfg.bg, color: cfg.text }}
      title={`${t(cfg.labelKey)} (${String(health.score)}${t('projects.health.unit')})\nSPI: ${String(health.spi ?? '-')} / ${t('projects.health.paceRatio')}: ${String(health.paceRatio ?? '-')} / ${t('projects.health.buffer')}: ${String(health.bufferRate ?? '-')}%`}
    >
      {health.grade}
    </span>
  );
}
